import { ReactComponent as ArrowHighlight } from '../../../../images/remote/interactive/arrow.svg';
import { css } from '@emotion/core';
import { ReactComponent as BackHighlight } from '../../../../images/remote/interactive/back.svg';
import { ReactComponent as OkHighlight } from '../../../../images/remote/interactive/ok.svg';
import { ReactComponent as PlayHighlight } from '../../../../images/remote/interactive/play_pause.svg';
import React from 'react';

export const Left =({opacity})=> <ArrowHighlight css={css`
  position: absolute;
  width: 14.8%;
    top: 24.8%;
    left: 29.3%;
    z-index: 10;
    opacity:${opacity};
    pointer-events: none;
`} />;



export const Right =({opacity})=> <ArrowHighlight css={css`
  position: absolute;
  transform: rotate(180deg);
  width: 14.8%;
  top: 24.8%;
  left: 55.5%;
  z-index: 10;
  opacity:${opacity};
  pointer-events: none;
`} />;



export const Up =({opacity})=> <ArrowHighlight css={css`
  position: absolute;
  transform: rotate(90deg);
  width: 14.8%;
  top: 17.5%;
  left: 42.7%;
  z-index: 10;
  opacity:${opacity};
  pointer-events: none;
`} />;


export const Down =({opacity})=> <ArrowHighlight css={css`
  position: absolute;
  transform: rotate(-90deg);
  width: 14.8%;
  top: 31.9%;
  left: 42.7%;
  z-index: 10;
  opacity:${opacity};
  pointer-events: none;
`} />;





export const Back =({opacity})=> <BackHighlight css={css`
  position: absolute;
    width: 15%;
    top: 14%;
    left: 42.4%;
    z-index: 10;
    opacity:${opacity};
    pointer-events: none;
`} />;


export const Ok = ({opacity})=> <OkHighlight css={css`
    position: absolute;
    top: 27.3%;
    left: 39.7%;
    width: 20%;
    z-index: 10;
    opacity:${opacity};
    pointer-events: none;
`} />;


export const Play = ({opacity})=> <PlayHighlight css={css`
  position: absolute;
    width: 15%;
    top: 47.8%;
    left: 33.3%;
    z-index: 10;
    opacity:${opacity};
    pointer-events: none;
`} />;



export const Mute = ({opacity})=> <PlayHighlight css={css`
  position: absolute;
  transform: rotate(-180deg);
    width: 15%;
    top: 47.8%;
    left: 51.3%;
    z-index: 10;
    opacity:${opacity};
    pointer-events: none;
`} />;
